import * as React from "react";
import { useNavigate } from "react-router";
import Spinner from "src/components/Spinner";
import styled from "styled-components";

const Card = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 40px 35px;

  margin-top: 60px;
  margin-bottom: 32px;
  max-width: 440px;
  max-height: 320px;

  /* Neutral/neutral-2 */
  background: #fafafa;

  /* Neutral/neutral-3 */
  border: 1px solid #dcdcdc;
  box-sizing: border-box;
  border-radius: 30px;
`;

const CardContent = styled.p`
  /* Regular / 20px | 28px */
  font-family: Open Sans;
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;

  /* or 140% */

  /* Neutral/neutral-6 */
  color: #000000;

  /* Inside Auto Layout */
  flex: none;
  order: 1;
  flex-grow: 0;
  margin: 10px 0px;
`;

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  height: 100vh;
  background-color: white;
`;

const BranchSMS: React.FC = () => {
  const [loading, setLoading] = React.useState(true);
  const [exhibitId, setExhibitId] = React.useState<string | null>(null);
  const navigate = useNavigate();

  React.useEffect(() => {
    // Get data from branch.io
    if (window.branch) {
      window.branch.data((error, response) => {
        if (error) {
          console.error("Branch.io error:", error);
          setLoading(false);
          return;
        }

        try {
          const id = response.data_parsed.exhibit_id;
          setExhibitId(id);

          // Just redirect to the topic page, let the Exhibit component handle loading
          if (id) {
            navigate(`/topic/${id}`);
          } else {
            setLoading(false);
          }
        } catch (err) {
          console.error("Error processing branch data:", err);
          setLoading(false);
        }
      });
    } else {
      // No branch.io available
      setLoading(false);
    }
  }, [navigate]);

  if (loading) {
    return (
      <Container>
        <Spinner />
      </Container>
    );
  }

  if (!exhibitId) {
    return (
      <Container>
        <Card>
          <CardContent>
            Please re-use your Viiision Link to download this app
          </CardContent>
        </Card>
      </Container>
    );
  }

  return null; // Should redirect before reaching here
};

export default BranchSMS;
